const NotFound = () => {
    return (
        <div className="d-flex flex-column align-items-center justify-content-center vh-100">
            <h1 className="text-center">PAGE NOT FOUND</h1>
        </div>
    );
};

export default NotFound;
